import Vue from "vue";
import Router from "vue-router";
import HomePage from "./views/HomePage.vue";
import store from "./store.js";
import auth from "./services/auth";

Vue.use(Router);

const hasTopup = (module) => store.state.auth.enabledTopUps.includes(module);

// export default new Router({
const router = new Router({
    mode: "history",
    base: process.env.BASE_URL,
    linkExactActiveClass: "active",
    routes: [
        {
            path: "/onboarding",
            name: "onboarding",
            component: () => import("./views/onboarding/OnboardingPage.vue"),
            meta: {
                requireAuth: true,
            },
            beforeEnter(to, from, next) {
                if (!store.getters['auth/isAdmin']) {
                    next("/account");
                }
                
                next();
            }
        },
        {

            path: "/onboarding/payout/requirements",
            component: () => import("./views/onboarding/OnboardingPayoutPage.vue"),
            name: "onboarding-payout-requirements",
            meta: {
                requireAuth: true
            },
        },
        {
            path: "/reset/password/:token",
            name: "reset-password",
            component: () => import("./views/ResetPasswordPage.vue"),
            meta: {
                requireAuth: false
            }
        },
        {
            path: "/login/:email_validation_code?",
            name: "login",
            component: () => import("./views/LoginPage.vue"),
            meta: {
                requireAuth: false
            }
        },
        {
            path: "/otp",
            name: "otp",
            component: () => import("./views/OTPPage.vue"),
            meta: {
                requireAuth: false
            },
            beforeEnter(to, from, next) {
                if (auth.getOtpTokenId()) {
                    next();
                } else {
                    next("/login");
                }
            }
        },
        {
            path: "/",
            redirect: "/account",
            name: "home",
            component: HomePage,
            meta: {
                requireAuth: true,
                routeGroup: []
            }
        },
        {
            path: "/setup",
            redirect: "/setup/start",
            component: () => import("./views/setup/Setup.vue"),
            meta: {
                requireAuth: true
            },
            children: [
                {
                    path: "start",
                    component: () => import("./views/setup/StartSetup.vue")
                },
                {
                    path: "step-2",
                    component: () => import("./views/setup/Step2.vue")
                },
                {
                    path: "step-3",
                    component: () => import("./views/setup/Step3.vue")
                }
            ]
        },
        {
            path: "/upgrade",
            redirect: "/upgrade/start",
            component: () => import("./views/upgrade/Setup.vue"),
            meta: {
                requireAuth: true
            },
            children: [
                {
                    path: "start",
                    component: () => import("./views/upgrade/StartSetup.vue")
                },
                {
                    path: "step-2",
                    component: () => import("./views/upgrade/Step2.vue")
                },
                {
                    path: "step-3",
                    component: () => import("./views/upgrade/Step3.vue")
                },
                {
                    path: "success",
                    component: () => import("./views/upgrade/Success.vue")
                }
            ]
        },
        {
            path: "/verify",
            component: () => import("./views/verify/Verify.vue")
        },
        {
            path: "/analytics",
            component: () => import("./views/analytics/AnalyticsPage.vue"),
            meta: {
                requireAuth: true,
                requirePermission: true,
                restrictMarketplace: true,
                access: "analytics.analytics",
                routeGroup: [
                    {
                        path: "/analytics/dashboard",
                        access: "analytics.analytics"
                    },
                    {
                        path: "/analytics/estore-quicksight",
                        access: "analytics.estore-quicksight"
                    },
                    {
                        path: "/analytics/estore-analytics",
                        access: "analytics.estore"
                    },
                    {
                        path: "/analytics/loyalty-analytics",
                        access: "analytics.loyalty-quicksight"
                    },
                    {
                        path: "/analytics/inquiro",
                        access: "analytics.inquiro"
                    },
                    {
                        path: "/analytics/sales",
                        access: "analytics.sales"
                    },
                    {
                        path: "/analytics/members",
                        access: "analytics.members"
                    },
                ]
            },
            children: [
                {
                    path: "dashboard",
                    name: "analytics",
                    component: () =>
                        import("./views/analytics/DashboardTab.vue"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "analytics.analytics",
                        module: "Analytics",
                        submodule: "Dashboard"
                    }
                },
                {
                    path: "inquiro",
                    component: () => import("./views/analytics/InquiroTab.vue"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "analytics.inquiro",
                        module: "Analytics",
                        submodule: "Inquiro"
                    }
                },
                {
                    path: "sales",
                    component: () => import("./views/analytics/SalesTab.vue"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "analytics.sales",
                        module: "Analytics",
                        submodule: "Sales"
                    }
                },
                {
                    path: "members",
                    component: () => import("./views/analytics/MembersTab.vue"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "analytics.members",
                        module: "Analytics",
                        submodule: "Members"
                    }
                },
                {
                    path: "estore-analytics",
                    name: "estore-analytics",
                    component: () => import("./views/analytics/DataStudio.vue"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "analytics.estore",
                        module: "Analytics",
                        submodule: "Estore Analytics"
                    }
                },
                {
                    path: "loyalty-analytics",
                    name: "loyalty-analytics",
                    component: () => import("@/views/analytics/LoyaltyAnalytics"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "analytics.loyalty-quicksight",
                        module: "Analytics",
                        submodule: "Loyalty Analytics"
                    },
                },
                {
                    path: "estore-quicksight",
                    name: "estore-quicksight",
                    component: () => import("./views/analytics/EstoreAnalytics.vue"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "analytics.estore-quicksight",
                        module: "Analytics",
                        submodule: "Estore Analytics"
                    }
                }
            ]
        },
        {
            path: "/mechanics",
            redirect: "/mechanics/achievement",
            component: () => import("./views/mechanics/MechanicsPage.vue"),
            meta: {
                requireAuth: true,
                requirePermission: true,
                restrictMarketplace: false,
                access: "mechanics.achievement",
                routeGroup: [
                    {
                        path: "/mechanics/achievement",
                        access: "mechanics.achievement"
                    },
                    {
                        path: "/mechanics/privilege-card",
                        access: "mechanics.privilege-card"
                    },
                    // {
                    //     path: "/mechanics/membership-tiers",
                    //     access: "mechanics.membership"
                    // },
                    {
                        path: "/mechanics/user-points",
                        access: "mechanics.points-mechanics"
                    },
                    {
                        path: "/mechanics/design",
                        access: "mechanics.design"
                    },
                    {
                        path: "/mechanics/guidelines",
                        access: "mechanics.guidelines"
                    },
                    {
                        path: "/mechanics/transactions",
                        access: "mechanics.transactions"
                    }
                ]
            },
            children: [
                {
                    path: "achievement",
                    component: () =>
                        import("./views/mechanics/AchievementTab.vue"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "mechanics.achievement",
                        module: "Program",
                        submodule: "Achievement"
                    }
                },
                {
                    name: "membershipTiers",
                    path: "membership-tiers",
                    component: () =>
                        import("./views/mechanics/MembershipTiersTab"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "mechanics.membership",
                        module: "Program",
                        submodule: "Membership Tierring"
                    }
                },
                {
                    name: "membershipTiersMembers",
                    path: "membership-tiers/members/:uuid",
                    component: () =>
                        import("./views/mechanics/MembershipTiersMembers.vue"),
                    props: true
                },
                {
                    path: "user-points",
                    component: () =>
                        import("./views/mechanics/UserPointsTab.vue"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "mechanics.points-mechanics",
                        module: "Program",
                        submodule: "Points Mechanics"
                    }
                },
                {
                    path: "guidelines",
                    component: () =>
                        import("./views/mechanics/GuidelinesTab.vue"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "mechanics.guidelines",
                        module: "Program",
                        submodule: "Guidelines"
                    }
                },
                {
                    path: "membership",
                    component: () =>
                        import("./views/mechanics/MembershipTab.vue"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "mechanics.membership",
                        module: "Program",
                        submodule: "Membership Tierring"
                    }
                },
                {
                    path: "design",
                    name: "designList",
                    component: () => import("./views/mechanics/DesignTab.vue"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "mechanics.design",
                        module: "Program",
                        submodule: "Design"
                    }
                },
                {
                    path: "design/create-customer-design",
                    component: () =>
                        import("./views/mechanics/designs/CustomerDesignForm.vue"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "mechanics.design",
                        module: "Program",
                        submodule: "Design"
                    }
                },
                {
                    path: "design/update-customer-design/:id",
                    component: () =>
                        import("./views/mechanics/designs/CustomerDesignForm.vue"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "mechanics.design",
                        module: "Program",
                        submodule: "Design"
                    }
                },
                {
                    path: "design/create-merchant-design",
                    component: () =>
                        import("./views/mechanics/designs/MerchantDesignForm.vue"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "mechanics.design",
                        module: "Program",
                        submodule: "Design"
                    }
                },
                {
                    path: "design/update-merchant-design/:id",
                    component: () =>
                        import("./views/mechanics/designs/MerchantDesignForm.vue"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "mechanics.design",
                        module: "Program",
                        submodule: "Design"
                    }
                },
                {
                    path: "capping",
                    redirect: "capping/notifications",
                    component: () => import("./views/mechanics/CappingTab.vue"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "mechanics.capping",
                        module: "Program",
                        submodule: "Capping"
                    },
                    children: [
                        {
                            path: "notifications",
                            component: () =>
                                import("./views/mechanics/capping/Notifications.vue"),
                            meta: {
                                requireAuth: true,
                                requirePermission: true,
                                access: "mechanics.capping",
                                module: "Program",
                                submodule: "Capping"
                            }
                        },
                        {
                            path: "transaction",
                            component: () =>
                                import("./views/mechanics/capping/TransactionCapping.vue"),
                            meta: {
                                requireAuth: true,
                                requirePermission: true,
                                access: "mechanics.capping",
                                module: "Program",
                                submodule: "Capping"
                            }
                        },
                        {
                            path: "amount",
                            component: () =>
                                import("./views/mechanics/capping/AmountCapping.vue"),
                            meta: {
                                requireAuth: true,
                                requirePermission: true,
                                access: "mechanics.capping",
                                module: "Program",
                                submodule: "Capping"
                            }
                        }
                    ]
                }
            ]
        },
        {
            path: "/design",
            name: "design",
            component: () => import("./views/design/DesignPage.vue"),
            meta: {
                requireAuth: true
            },
            children: [
                {
                    path: "gLife",
                    name: "gLifeDesign",
                    component: () => import("./views/design/GlifePage"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "design.glife",
                        module: "Design",
                        submodule: "GLife"
                    }
                },
                {
                    path: "app",
                    name: "appDesign",
                    component: () => import("./views/design/AppPage.vue"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "design.app",
                        module: "Design",
                        submodule: "App"
                    }
                },
                {
                    path: "web",
                    name: "web",
                    component: () => import("./views/design/WebPage.vue"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "design.web",
                        module: "Design",
                        submodule: "Web"
                    }
                },
                {
                    path: "advanced-settings",
                    redirect: "advanced-settings/icons-and-logos",
                    name: "advancedSettings",
                    component: () =>
                        import("./views/design/advanced-settings/Index.vue"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "design.advanced-settings",
                        module: "Design",
                        submodule: "Advanced Settings"
                    },
                    children: [
                        {
                            path: "icons-and-logos",
                            name: "designAdvancedSettingsIconsAndLogos",
                            component: () =>
                                import("./views/design/advanced-settings/IconsAndLogos.vue"),
                            meta: {
                                requireAuth: true,
                                requirePermission: true,
                                access: "design.advanced-settings"
                            }
                        },
                        {
                            path: "snippet-details",
                            name: "designAdvancedSettingsSnippetDetails",
                            component: () =>
                                import("./views/design/advanced-settings/SnippetDetails.vue"),
                            meta: {
                                requireAuth: true,
                                requirePermission: true,
                                access: "design.advanced-settings"
                            }
                        },
                        {
                            path: "order-status",
                            name: "designAdvancedSettingsOrderStatus",
                            component: () =>
                                import("./views/design/advanced-settings/order-status/Index.vue"),
                            meta: {
                                requireAuth: true,
                                requirePermission: true,
                                access: "design.advanced-settings"
                            }
                        },
                        {
                            path: "web-sequence",
                            name: "designAdvancedSettingsWebSequence",
                            component: () =>
                                import("./views/design/advanced-settings/WebSequence.vue"),
                            meta: {
                                requireAuth: true,
                                requirePermission: true,
                                access: "design.advanced-settings"
                            }
                        },
                        {
                            path: "about-us",
                            name: "designAdvancedSettingsAboutUs",
                            component: () =>
                                import("./views/design/advanced-settings/AboutUs.vue"),
                            meta: {
                                requireAuth: true,
                                requirePermission: true,
                                access: "design.advanced-settings"
                            }
                        },
                        {
                            path: "categories",
                            name: "designAdvancedSettingsCategories",
                            component: () =>
                                import("./views/design/advanced-settings/Categories.vue"),
                            meta: {
                                requireAuth: true,
                                requirePermission: true,
                                access: "design.advanced-settings"
                            }
                        },
                        {
                            path: "our-brands",
                            name: "designAdvancedSettingsOurBrands",
                            component: () =>
                                import("./views/design/advanced-settings/OurBrands.vue"),
                            meta: {
                                requireAuth: true,
                                requirePermission: true,
                                access: "design.advanced-settings"
                            }
                        },
                        {
                            path: "featured-products",
                            name: "designAdvanceSettingsFeaturedProducts",
                            component: () =>
                                import("./views/design/advanced-settings/FeaturedProducts.vue")
                        }
                    ]
                },
                {
                    path: "web/create-web-design",
                    name: "createWebDesign",
                    component: () =>
                        import("./views/design/webdesigns/CreateWebDesign.vue"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "design.web"
                    }
                },
                {
                    path: "web/edit-web-design/:id",
                    component: () =>
                        import("./views/design/webdesigns/EditWebDesign.vue"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "design.web",
                        module: "Design",
                        submodule: "Web"
                    },
                    props: true
                },
                {
                    path: "estorebanner",
                    name: "estorebanner",
                    component: () => import("./views/design/EstoreBanner.vue"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "design.estore-banner",
                        module: "Design",
                        submodule: "E-Store Banner"
                    }
                },
                {
                    path: "estorebanner/create-banner",
                    component: () => import("./views/design/CreateBanner.vue"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "design.estore-banner",
                        module: "Design",
                        submodule: "E-Store Banner"
                    }
                },
                {
                    path: "estorebanner/edit-banner/:id",
                    component: () =>
                        import("./views/design/estore/EditBanner.vue"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "design.estore-banner",
                        module: "Design",
                        submodule: "E-Store Banner"
                    },
                    props: true
                },
                {
                    path: "design/create-customer-design",
                    component: () =>
                        import("./views/design/designs/CustomerDesignForm.vue"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "design.app",
                        module: "Design",
                        submodule: "App"
                    }
                },
                {
                    path: "design/update-customer-design/:id",
                    component: () =>
                        import("./views/design/designs/CustomerDesignForm.vue"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "design.app",
                        module: "Design",
                        submodule: "App"
                    }
                },
                {
                    path: "design/create-merchant-design",
                    component: () =>
                        import("./views/design/designs/MerchantDesignForm.vue"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "design.app",
                        module: "Design",
                        submodule: "App"
                    }
                },
                {
                    path: "design/update-merchant-design/:id",
                    component: () =>
                        import("./views/design/designs/MerchantDesignForm.vue"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "design.app",
                        module: "Design",
                        submodule: "App"
                    }
                },
                {
                    path: "design/create-glife-design",
                    component: () =>
                        import("./views/design/designs/GLifeDesignForm.vue"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "design.glife",
                        module: "Design",
                        submodule: "Glife"
                    }
                },
                {
                    path: "design/update-glife-design/:id",
                    component: () =>
                        import("./views/design/designs/GLifeDesignForm.vue"),
                    name: "UpdateGlifeDesign",
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "design.glife",
                        module: "Design",
                        submodule: "Glife"
                    }
                }
            ]
        },
        {
            path: "/rewards",
            redirect: "/rewards/my-rewards",
            component: () => import("./views/rewards/RewardsPage.vue"),
            meta: {
                requireAuth: true,
                requirePermission: true,
                restrictMarketplace: false,
                access: "rewards.my-rewards",
                module: "Rewards",
                submodule: "Rewards",
                routeGroup: [
                    {
                        path: "/rewards/my-rewards",
                        access: "rewards.my-rewards"
                    }
                ]
            },
            children: [
                {
                    name: "MyRewards",
                    path: "my-rewards",
                    component: () => import("./views/rewards/MyRewardsTab.vue"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "rewards.my-rewards",
                        module: "Rewards",
                        submodule: "Rewards"
                    }
                },
                {
                    name: "MyRewardsV2",
                    path: "my-rewards-v2",
                    component: () =>
                        import("./views/rewards/MyRewardsTabV2.vue"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "rewards.my-rewards",
                        module: "Rewards",
                        submodule: "Rewards"
                    }
                },
                {
                    name: "MyRewardsCodes",
                    path: "my-rewards/:rewardUuid/codes",
                    component: () =>
                        import("./views/rewards/MyRewardsCodesTab.vue"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "rewards.my-rewards",
                        module: "Rewards",
                        submodule: "Rewards"
                    },
                    props: true
                }
            ]
        },
        {
            path: "/engagement",
            redirect: "/engagement/broadcasting",
            component: () => import("./views/engagement/EngagementPage.vue"),
            meta: {
                requireAuth: true,
                requirePermission: true,
                restrictMarketplace: true,
                access: "engagement.broadcasting",
                routeGroup: [
                    {
                        path: "/engagement/broadcasting",
                        access: "engagement.broadcasting"
                    },
                    {
                        path: "/engagement/news",
                        access: "engagement.news"
                    },
                    {
                        path: "/engagement/survey",
                        access: "engagement.f/y"
                    }
                ]
            },
            children: [
                {
                    path: "broadcasting",
                    name: "Broadcasting",
                    component: () =>
                        import("./views/engagement/BroadcastingTab.vue"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "engagement.broadcasting",
                        module: "Engagement",
                        submodule: "Broadcasting"
                    }
                },
                {
                    path: "broadcasting/design/:uuid?",
                    name: "broadcastingDesign",
                    component: () =>
                        import("./views/engagement/broadcasting/CreateBroadcast"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "engagement.broadcasting",
                        module: "Engagement",
                        submodule: "Broadcasting"
                    },
                    props: true
                },
                {
                    name: "notifications",
                    path: "notifications",
                    component: () =>
                        import("./views/engagement/NotificationsTab.vue"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "engagement.notifications",
                        module: "Engagement",
                        submodule: "Dynamic Notification"
                    }
                },
                {
                    name: "engagementNews",
                    path: "news",
                    component: () => import("./views/engagement/NewsTab.vue"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "engagement.news",
                        module: "Engagement",
                        submodule: "News"
                    }
                },

                {
                    name: "engagementNewsPopUp",
                    path: "news-popup",
                    component: () =>
                        import("./views/engagement/NewsAndPopUpTab.vue"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "engagement.news-and-popup",
                        module: "Engagement",
                        submodule: "News & Popup"
                    }
                },
                {
                    path: "facebook-ads",
                    component: () =>
                        import("./views/engagement/FacebookAdsTab.vue"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "engagement.facebook-ads",
                        module: "Engagement",
                        submodule: "Facebook Ads"
                    }
                },
                {
                    path: "survey",
                    component: () => import("./views/engagement/SurveyTab"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "engagement.survey",
                        module: "Engagement",
                        submodule: "Survey"
                    }
                },
                {
                    name: "engagementPopupDesign",
                    path: "popup/design/:type/:uuid?",
                    component: () =>
                        import("./views/engagement/PopupDesignPage"),
                    props: true,
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "engagement.news-and-popup",
                        module: "Engagement",
                        submodule: "News & Popup"
                    }
                },
                {
                    name: "engagementNewsDesign",
                    path: "news/design/:uuid?",
                    component: () =>
                        import("./views/engagement/NewsDesignPage"),
                    props: true,
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "engagement.news-and-popup",
                        module: "Engagement",
                        submodule: "News & Popup"
                    }
                }
            ]
        },
        {
            path: "/store",
            redirect: "store/organization",
            component: () => import("./views/store/StorePage.vue"),
            meta: {
                requireAuth: true,
                requirePermission: true,
                restrictMarketplace: false,
                access: "store.organization",
                routeGroup: [
                    {
                        path: "/store/organization",
                        access: "store.organization"
                    },
                    {
                        path: "/store/employee",
                        access: "store.employee"
                    },
                    {
                        path: "/store/dine-in",
                        access: "store.table_ordering:topup-table_ordering"
                    }
                ]
            },
            children: [
                {
                    name: "StoreOrganization",
                    path: "organization/:branch_uuid?",
                    component: () => import("./views/store/OrganizationTab.vue"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "store.organization",
                        module: "Store",
                        submodule: "Organization"
                    }
                },
                {
                    path: "employee",
                    component: () => import("./views/store/EmployeeTab.vue"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "store.employee",
                        module: "Store",
                        submodule: "Employee"
                    }
                },
                {
                    path: "dine-in",
                    redirect: { name: "DineInList" },
                    name: "StoreDineIn",
                    component: () => import("./views/store/DineInTab.vue"),
                    children: [
                        {
                            path: "list",
                            name: "DineInList",
                            component: () => import("./views/store/DineIn/DineInIndex.vue"),
                            meta: {
                                requireAuth: true,
                                requirePermission: true,
                                access: "store.table_ordering:topup-table_ordering",
                                module: "Store",
                                submodule: "Table Ordering"
                            }
                        },
                        {
                            path: "view/:uuid",
                            name: "ViewTables",
                            component: () => import("./views/store/DineIn/DineInViewTables.vue"),
                            meta: {
                                requireAuth: true,
                                requirePermission: true,
                                access: "store.table_ordering:topup-table_ordering",
                                module: "Store",
                                submodule: "Table Ordering"
                            }
                        },
                        {
                            path: "create",
                            name: "DineInCreateTableGroup",
                            component: () => import("./views/store/DineIn/DineInCreateTableGroup.vue"),
                            meta: {
                                requireAuth: true,
                                requirePermission: true,
                                access: "store.table_ordering:topup-table_ordering",
                                module: "Store",
                                submodule: "Table Ordering"
                            }
                        },
                        {
                            path: "update/:uuid",
                            name: "DineInUpdateTableGroup",
                            component: () => import("./views/store/DineIn/DineInUpdateTableGroup.vue"),
                            meta: {
                                requireAuth: true,
                                requirePermission: true,
                                access: "store.table_ordering:topup-table_ordering",
                                module: "Store",
                                submodule: "Table Ordering"
                            }
                        }
                    ]
                }
            ]
        },
        {
            path: "/customers",
            redirect: "/customers/transaction-history",
            component: () => import("./views/customers/CustomerPage.vue"),
            meta: {
                requireAuth: true,
                requirePermission: true,
                restrictMarketplace: false,
                access: "customers.transaction-history",
                routeGroup: [
                    {
                        path: "/customers/transaction-history",
                        access: "customers.transaction-history"
                    },
                    {
                        path: "/customers/customized-transaction-history",
                        access: "customers.customized-transaction-history"
                    },
                    {
                        path: "/customers/list",
                        access: "customers.customers"
                    },
                    {
                        path: "/customers/feedbacks",
                        access: "customers.feedbacks"
                    },
                    {
                        path: "/customers/target-segment",
                        access: "customers.target-segment"
                    },
                    {
                        path: "/customers/hotline",
                        access: "customers.hotline"
                    },
                    {
                        path: "/customers/whitelist",
                        access: "customers.whitelist:topup-whitelist"
                    },
                    {
                        path: "/customers/key-account",
                        access: "customers.key-account"
                    }
                ]
            },
            children: [
                {
                    path: "transaction-history",
                    name: "transaction-history",
                    component: () =>
                        import("./views/customers/CustomerTransactionHistory.vue"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "customers.transaction-history",
                        module: "Customers",
                        submodule: "Transaction History"
                    }
                },
                {
                    path: "customized-transaction-history",
                    name: "customized-transaction-history",
                    component: () =>
                        import("./views/customers/CustomizedTransactionHistory.vue"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "customers.customized-transaction-history",
                        module: "Customers",
                        submodule: "Transaction History"
                    }
                },
                {
                    path: "list",
                    name: "customers",
                    component: () =>
                        import("./views/customers/CustomerList.vue"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "customers.customers",
                        module: "Customers",
                        submodule: "Customers"
                    }
                },
                {
                    path: "feedbacks",
                    component: () =>
                        import("./views/customers/CustomerFeedbacks.vue"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "customers.feedbacks",
                        module: "Customers",
                        submodule: "Feedbacks"
                    }
                },
                {
                    path: "target-segment",
                    component: () =>
                        import("./views/customers/CustomerTargetSegment.vue"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "customers.target-segment",
                        module: "Customers",
                        submodule: "Target Segment"
                    },
                    children: [
                        {
                            path: "/",
                            component: () =>
                                import("./views/customers/TargetSegmentList.vue"),
                            meta: {
                                requireAuth: true,
                                requirePermission: true,
                                access: "customers.target-segment",
                                module: "Customers",
                                submodule: "Target Segment"
                            }
                        },
                        {
                            path: "create",
                            component: () =>
                                import("./views/customers/NewTargetSegment.vue"),
                            meta: {
                                requireAuth: true,
                                requirePermission: true,
                                access: "customers.target-segment",
                                module: "Customers",
                                submodule: "Target Segment"
                            }
                        },
                        {
                            path: "edit",
                            component: () =>
                                import("./views/customers/EditTargetSegment.vue"),
                            meta: {
                                requireAuth: true,
                                requirePermission: true,
                                access: "customers.target-segment",
                                module: "Customers",
                                submodule: "Target Segment"
                            }
                        }
                    ]
                },
                {
                    path: "target-segment/create",
                    component: () =>
                        import("./views/customers/NewTargetSegment.vue"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "customers.target-segment",
                        module: "Customers",
                        submodule: "Target Segment"
                    }
                },
                {
                    path: "hotline",
                    component: () =>
                        import("./views/customers/CustomerHotline.vue"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "customers.hotline",
                        module: "Customers",
                        submodule: "Hotline"
                    }
                },
                {
                    path: "whitelist",
                    component: () =>
                        import("./views/customers/CustomerWhitelist.vue"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "customers.whitelist:topup-whitelist",
                        module: "Customers",
                        submodule: "Whitelist"
                    }
                },
                {
                    path: "key-account",
                    component: () =>
                        import("./views/customers/CustomerKeyAccount.vue"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "customers.key-account",
                        module: "Customers",
                        submodule: "Key Account"
                    }
                }
            ]
        },
        {
            path: "/booking",
            redirect: "/booking/class",
            component: () => import("./views/booking/BookingPage.vue"),
            meta: {
                requireAuth: true,
                requirePermission: true,
                restrictMarketplace: true,
                access: "booking:topup.class:topup-booking",
                routeGroup: [
                    {
                        path: "/booking/class",
                        access: "booking:topup.class:topup-booking"
                    },
                    {
                        path: "/booking/instructor",
                        access: "booking:topup.instructor:topup-booking"
                    },
                    {
                        path: "/booking/scheduler",
                        access: "booking:topup.scheduler:topup-booking"
                    },
                    {
                        path: "/booking/package",
                        access: "booking:topup.package:topup-booking"
                    },
                    {
                        path: "/booking/settings",
                        access: "booking:topup.settings:topup-booking"
                    }
                ]
            },
            children: [
                {
                    path: "class",
                    name: "class",
                    component: () => import("./views/booking/ClassTab.vue"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "booking:topup.class:topup-booking",
                        module: "Booking",
                        submodule: "Class"
                    }
                },
                {
                    path: "instructor",
                    name: "instructor",
                    component: () =>
                        import("./views/booking/InstructorTab.vue"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "booking:topup.instructor:topup-booking",
                        module: "Booking",
                        submodule: "Instructor"
                    }
                },
                {
                    path: "scheduler",
                    name: "scheduler",
                    component: () => import("./views/booking/SchedulerTab.vue"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "booking:topup.scheduler:topup-booking",
                        module: "Booking",
                        submodule: "Scheduler"
                    }
                },
                {
                    path: "package",
                    name: "package",
                    component: () => import("./views/booking/PackageTab.vue"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "booking:topup.package:topup-booking",
                        module: "Booking",
                        submodule: "Package"
                    }
                },
                {
                    path: "settings",
                    name: "bookingSettings",
                    component: () => import("./views/booking/SettingsTab.vue"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "booking:topup.settings:topup-booking",
                        module: "Booking",
                        submodule: "Settings"
                    }
                }
            ]
        },
        {
            path: "/dstore",
            redirect: "/dstore/products",
            component: () => import("./views/dstore/DStore"),
            meta: {
                requireAuth: true,
                requirePermission: true,
                restrictMarketplace: true,
                access: "dstore:topup.inventory:topup-dstore",
                routeGroup: [
                    {
                        path: "/dstore/products",
                        access: "dstore:topup.inventory:topup-dstore"
                    },
                    {
                        path: "/dstore/orders",
                        access: "dstore:topup.orders:topup-dstore"
                    },
                    {
                        path: "/dstore/store-vouchers",
                        access: "dstore:topup.vouchers:topup-dstore"
                    },
                    {
                        path: "/dstore/design",
                        access: "dstore:topup.design:topup-dstore"
                    },
                    {
                        path: "/dstore/activation-key",
                        access: "dstore:topup.activation:topup-dstore"
                    },
                    {
                        path: "/dstore/settings",
                        access: "dstore:topup.settings:topup-dstore"
                    }
                ]
            },
            children: [
                {
                    path: "products",
                    name: "dstoreProducts",
                    component: () => import("./views/dstore/DStoreProductsTab"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "dstore:topup.inventory:topup-dstore",
                        module: "D-Store",
                        submodule: "Products"
                    }
                },
                {
                    path: "products/:id/activation-keys",
                    name: "dstoreProductsActivationKeys",
                    component: () =>
                        import("./views/dstore/DStoreProductsActivationKeys"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "dstore:topup.activation:topup-dstore",
                        module: "D-Store",
                        submodule: "Activation Keys"
                    }
                },
                {
                    path: "orders",
                    name: "dstoreOrders",
                    component: () => import("./views/dstore/DStoreOrdersTab"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "dstore:topup.orders:topup-dstore",
                        module: "D-Store",
                        submodule: "Orders"
                    }
                },
                {
                    path: "store-vouchers",
                    name: "dstoreStoreVouchers",
                    component: () => import("./views/dstore/DStoreVouchersTab"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "dstore:topup.vouchers:topup-dstore",
                        module: "D-Store",
                        submodule: "Store Vouchers"
                    }
                },
                {
                    path: "design",
                    name: "dstoreDesign",
                    component: () => import("./views/dstore/DStoreDesignTab"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "dstore:topup.design:topup-dstore",
                        module: "D-Store",
                        submodule: "Design"
                    }
                },
                {
                    path: "design/create-customer-design",
                    name: "dstoreCreateCustomerDesign",
                    component: () =>
                        import("./views/dstore/designs/CustomerDesignForm.vue"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "dstore:topup.design:topup-dstore",
                        module: "D-Store",
                        submodule: "Design"
                    }
                },
                {
                    path: "design/update-customer-design/:id",
                    component: () =>
                        import("./views/dstore/designs/CustomerDesignForm.vue"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "dstore:topup.design:topup-dstore",
                        module: "D-Store",
                        submodule: "Design"
                    }
                },
                {
                    path: "activation-key",
                    name: "dstoreActivationKey",
                    component: () =>
                        import("./views/dstore/DStoreActivationKeyTab"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "dstore:topup.activation:topup-dstore",
                        module: "D-Store",
                        submodule: "Activation Keys"
                    }
                },
                {
                    path: "settings",
                    name: "dstoreSettings",
                    component: () => import("./views/dstore/DStoreSettingsTab"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "dstore:topup.settings:topup-dstore",
                        module: "D-Store",
                        submodule: "Settings"
                    }
                }
            ]
        },
        {
            path: "/documents",
            component: () => import("./views/documents/DocumentsTab.vue"),
            meta: {
                requireAuth: true,
                requirePermission: true,
                restrictMarketplace: true,
                access: "documents:topup.documents:topup-documents",
                module: "Documents",
                submodule: "Documents"
            }
        },
        {
            path: "/wallet",
            redirect: "/wallet/list",
            component: () => import("./views/wallet/WalletPage.vue"),
            meta: {
                requireAuth: true,
                requirePermission: true,
                access: "wallet.list",
                routeGroup: [
                    {
                        path: "/wallet/list",
                        access: "s-wallet.wallet"
                    },
                    {
                        path: "/wallet/archive",
                        access: "s-wallet.archive"
                    },
                    {
                        path: "/wallet/history",
                        access: "s-wallet.wallet-history"
                    },
                    {
                        path: "/wallet/capping",
                        access: "s-wallet.wallet-capping"
                    },
                ]
            },
            children: [
                {
                    path: "list",
                    name: "wallet",
                    component: () => import("./views/wallet/WalletTab.vue"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "s-wallet.wallet",
                        module: "Rush Wallet",
                        submodule: "Wallet"
                    }
                },
                {
                    path: "archive",
                    name: "archive",
                    component: () => import("./views/wallet/ArchiveTab.vue"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "s-wallet.archive",
                        module: "Rush Wallet",
                        submodule: "Archive"
                    }
                },
                {
                    path: "history",
                    name: "walletHistory",
                    component: () => import("./views/wallet/HistoryTab.vue"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "s-wallet.wallet-history",
                        module: "Rush Wallet",
                        submodule: "Wallet History"
                    }
                },
                {
                    path: "capping",
                    name: "wallet-capping",
                    component: () => import("./views/wallet/CappingTab.vue"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "s-wallet.wallet-capping",
                        module: "Rush Wallet",
                        submodule: "Wallet Capping"
                    }
                }
            ]
        },
        {
            path: "/vouchers",
            component: () => import("./views/vouchers/VouchersTab.vue"),
            meta: {
                requireAuth: true,
                requirePermission: true,
                restrictMarketplace: true,
                access: "vouchers:topup.vouchers:topup-vouchers",
                module: "Vouchers",
                submodule: "Vouchers"
            }
        },
        {
            path: "/account",
            redirect: "/account/profile",
            component: () => import("./views/account/AccountPage.vue"),
            meta: {
                requireAuth: true,
                requirePermission: true,
                routeGroup: []
            },
            children: [
                {
                    path: "profile",
                    component: () => import("./views/account/ProfileTab.vue"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        validateStep: true,
                        access: "account-settings.my-profile",
                        module: "Account Settings",
                        submodule: "My Profile"
                    },
                    beforeEnter: async (to, from, next) => {
                        let hasPasswordUpdated = store.state.auth.hasPasswordUpdated
                        let onBoardingCompleted = store.getters['onboarding/step1AndStep2Completed']


                        if (hasPasswordUpdated === 0) {
                            localStorage.setItem('successModal', 'true');
                            next("/account/security");
                        }
                        else if (hasTopup("estore") && !onBoardingCompleted) {
                            next('/onboarding')
                        }
                        else {
                            next();
                        }
                    },
                },
                {
                    path: "terms",
                    component: () => import("./views/account/TermsTab.vue"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "account-settings.terms",
                        module: "Account Settings",
                        submodule: "Terms"
                    }
                },
                {
                    path: "users",
                    component: () => import("./views/account/UsersTab.vue"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "account-settings.users",
                        module: "Account Settings",
                        submodule: "Users"
                    }
                },
                {
                    path: "security",
                    component: () => import("./views/account/SecurityTab.vue"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "account-settings.security",
                        module: "Account Settings",
                        submodule: "Security"
                    }
                },
                {
                    path: "extensions",
                    component: () =>
                        import("./views/account/ExtensionsTab.vue"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        restrictMarketplace: true,
                        access: "account-settings.extensions",
                        module: "Account Settings",
                        submodule: "Extensions"
                    }
                },
                {
                    path: "documents",
                    component: () => import("./views/account/DocumentsTab.vue"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        restrictMarketplace: true,
                        access: "account-settings.documents",
                        module: "Account Settings",
                        submodule: "Documents"
                    }
                }
            ]
        },
        {
            path: "/billing",
            redirect: "/billing/account",
            component: () => import("./views/billing/BillingPage.vue"),
            meta: {
                requireAuth: true,
                restrictMarketplace: true
            },
            children: [
                {
                    path: "account",
                    name: "account",
                    component: () =>
                        import("./views/billing/BillingAccountTab.vue"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "billing.account",
                        module: "Billing",
                        submodule: "Account"
                    }
                },
                {
                    path: "history",
                    name: "billingHistory",
                    component: () =>
                        import("./views/billing/BillingHistoryTab.vue"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "billing.billing-history",
                        module: "Billing",
                        submodule: "Billing History"
                    }
                },
                {
                    path: "information",
                    name: "information",
                    component: () =>
                        import("./views/billing/BillingInformation.vue"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "billing.information",
                        module: "Billing",
                        submodule: "Information"
                    }
                }
            ]
        },
        {
            path: "/reports",
            redirect: "/reports/outlet-master",
            component: () => import("./views/reports/ReportsPage.vue"),
            meta: {
                requireAuth: true,
                requirePermission: true,
                restrictMarketplace: true,
                access: "reports:topup.outlet:topup-reports",
                routeGroup: [
                    {
                        path: "/reports/outlet-master",
                        access: "reports:topup.outlet:topup-reports"
                    },
                    {
                        path: "/reports/asset-master",
                        access: "reports:topup.asset:topup-reports"
                    },
                    {
                        path: "/reports/srp-database",
                        access: "reports:topup.srp:topup-reports"
                    },
                    {
                        path: "/reports/channel-matrix",
                        access: "reports:topup.matrix:topup-reports"
                    },
                    {
                        path: "/reports/transaction-upload",
                        access: "reports:topup.transaction-upload"
                    }
                ]
            },
            children: [
                {
                    path: "outlet-master",
                    name: "outlet-master",
                    component: () =>
                        import("./views/reports/OutletMasterTab.vue"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "reports:topup.outlet:topup-reports",
                        module: "Master Data",
                        submodule: "Outlet Master"
                    }
                },
                {
                    path: "asset-master",
                    name: "asset-master",
                    component: () =>
                        import("./views/reports/AssetMasterTab.vue"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "reports:topup.asset:topup-reports",
                        module: "Master Data",
                        submodule: "Asset Master"
                    }
                },
                {
                    path: "srp-database",
                    name: "srp-database",
                    component: () =>
                        import("./views/reports/SRPDatabaseTab.vue"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "reports:topup.srp:topup-reports",
                        module: "Master Data",
                        submodule: "SRP Database"
                    }
                },
                {
                    path: "channel-matrix",
                    name: "channel-matrix",
                    component: () =>
                        import("./views/reports/ChannelMatrixTab.vue"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "reports:topup.matrix:topup-reports",
                        module: "Master Data",
                        submodule: "Channel Matrix"
                    }
                },
                {
                    path: "transaction-upload",
                    name: "transaction-upload",
                    component: () =>
                        import("./views/reports/TransactionUploadTab.vue"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "reports:topup.transaction-upload",
                        module: "Master Data",
                        submodule: "Transaction Upload"
                    }
                }
            ]
        },
        {
            name: "survey",
            path: "/survey",
            component: () => import("./views/survey/pages/MainSurveyPage.vue"),
            meta: {
                requireAuth: true,
                requirePermission: true,
                access: "survey:topup.survey:topup-survey",
                module: "Survey",
                submodule: "Survey"
            }
        },
        {
            name: "surveyQuestion",
            path: "/survey-question/:uuid?",
            component: () =>
                import("./views/survey/pages/SurveyQuestionPage.vue"),
            meta: {
                requireAuth: true,
                requirePermission: true,
                access: "survey:topup.survey:topup-survey",
                module: "Survey",
                submodule: "Survey"
            },
            props: true
        },
        {
            name: "surveyDesign",
            path: "/survey-design/:uuid?",
            component: () =>
                import("./views/survey/pages/SurveyDesignPage.vue"),
            meta: {
                requireAuth: true,
                requirePermission: true,
                access: "survey:topup.survey:topup-survey",
                module: "Survey",
                submodule: "Survey"
            },
            props: true
        },
        {
            name: "Plugins",
            path: "/plugins",
            component: () => import("./views/plugins/Plugins"),
            redirect: "/plugins/marketplace",
            meta: {
                requireAuth: true
            },
            children: [
                {
                    path: "marketplace",
                    name: "PluginsMarketplace",
                    component: () =>
                        import("./views/plugins/marketplace/Marketplace"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "plugins.marketplace",
                        module: "Plugins",
                        submodule: "Marketplace"
                    }
                },
                {
                    path: "gamification",
                    name: "PluginsGamification",
                    component: () =>
                        import("./views/plugins/gamification/Gamification"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "plugins.gamification",
                        module: "Plugins",
                        submodule: "Gamification"
                    }
                }
            ]
        },
        {
            path: "/maintenance",
            name: "maintenance",
            component: () => import("./views/Maintenance.vue"),
            meta: {
                requireAuth: true
            }
        },
        {
            path: "/404",
            name: "404",
            component: () => import("./views/PageNotFound.vue")
        },
        {
            path: "*",
            name: "any",
            component: () => import("./views/PageNotFound.vue")
        },
        {
            path: "/fulfillment",
            name: "Fulfillment",
            component: () => import("./views/fulfillment/Fulfillment"),
            redirect: "fulfillment/delivery",
            meta: {
                requireAuth: true
            },
            children: [
                {
                    path: "delivery",
                    component: () =>
                        import("./views/fulfillment/FulfillmentDelivery"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "fulfillment.delivery",
                        module: "Order Fulfillment",
                        submodule: "Delivery"
                    },
                    children: [
                        {
                            path: "/",
                            name: "FulfillmentDelivery",
                            component: () =>
                                import("./views/fulfillment/delivery/DeliveryIndex"),
                            meta: {
                                requireAuth: true,
                                requirePermission: true,
                                access: "fulfillment.delivery",
                                module: "Order Fulfillment",
                                submodule: "Delivery"
                            }
                        },
                        {
                            path: "pre-ordering/:brand_uuid/:branch_uuid",
                            name: "FulfillmentDeliveryPreOrdering",
                            component: () =>
                                import("@/components/fulfillment/PreOrderingComponent"),
                            meta: {
                                requireAuth: true,
                                requirePermission: true,
                                access: "fulfillment.delivery",
                                module: "Order Fulfillment",
                                submodule: "Delivery"
                            }
                        }
                    ]
                },
                {
                    path: "pickup",
                    component: () =>
                        import("./views/fulfillment/FulfillmentPickup"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "fulfillment.pickup",
                        module: "Order Fulfillment",
                        submodule: "Pickup"
                    },
                    children: [
                        {
                            path: "/",
                            name: "FulfillmentPickup",
                            component: () =>
                                import("./views/fulfillment/pickup/PickupIndex"),
                            meta: {
                                requireAuth: true,
                                requirePermission: true,
                                access: "fulfillment.pickup",
                                module: "Order Fulfillment",
                                submodule: "Pickup"
                            }
                        },
                        {
                            path: "pre-ordering/:brand_uuid/:branch_uuid",
                            name: "FulfillmentPickupPreOrdering",
                            component: () =>
                                import("@/components/fulfillment/PreOrderingComponent"),
                            meta: {
                                requireAuth: true,
                                requirePermission: true,
                                access: "fulfillment.pickup",
                                module: "Order Fulfillment",
                                submodule: "Pickup"
                            }
                        }
                    ]
                },
                {
                    path: "fees",
                    name: "FulfillmentFees",
                    component: () =>
                        import("./views/fulfillment/FulfillmentFees"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "fulfillment.fees",
                        module: "Order Fulfillment",
                        submodule: "Fees"
                    }
                },
                {
                    path: "settings",
                    name: "FulfillmentSettings",
                    component: () =>
                        import("./views/fulfillment/FulfillmentSettings"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "fulfillment.settings",
                        module: "Order Fulfillment",
                        submodule: "Settings"
                    }
                }
            ]
        },
        {
            path: "/my-plan",
            redirect: "/my-plan/details",
            name: "MyPlan",
            component: () => import("./views/my-plan/MyPlanPage"),
            meta: {
                requireAuth: true
            },
            children: [
                {
                    path: "details",
                    name: "MyPlanDetails",
                    component: () => import("./views/my-plan/MyPlanDetails"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "my-plan.plan-details",
                        module: "My Plan",
                        submodule: "Plan Details"
                    }
                },
                {
                    path: "billing-history",
                    name: "MyPlanBillingHistory",
                    component: () =>
                        import("./views/my-plan/MyPlanBillingHistory"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "my-plan.plan-billing-history",
                        module: "My Plan",
                        submodule: "Billing History"
                    }
                },
                {
                    path: "payout-history",
                    name: "MyPlanPayoutHistory",
                    component: () => import("./views/my-plan/MyPlanPayoutHistory.vue"),
                    meta: {
                        requireAuth: true,
                        requirePermission: false,
                        access: "my-plan.plan-billing-history",
                        module: "My Plan",
                        submodule: "Payout History"
                    }
                },
                {
                    path: "add-credit-card",
                    name: "AddCreditCardDetails",
                    component: () =>
                        import("./views/my-plan/AddCreditCardDetails"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "my-plan.plan-details",
                        module: "My Plan",
                        submodule: "Plan Details"
                    }
                },
                {
                    path: "details/manage-subscription",
                    name: "ManageSubscription",
                    component: () =>
                        import("./views/my-plan/ManageSubscription"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "my-plan.plan-details",
                        module: "My Plan",
                        submodule: "Plan Details"
                    }
                }
            ]
        },
        {
            path: "/rush-academy/:video?",
            name: "RushAcademy",
            component: () => import("@/views/rush-academy/RushAcademyPage"),
            meta: {
                requireAuth: true,
                requirePermission: true,
                access: "account-settings.my-profile",
                module: "Rush Academy",
                submodule: "Rush Academy"
            }
        },
        {
            path: "/conversational-commerce",
            name: "ConversationalCommerce",
            component: () => import("@/views/conversational-commerce/ConversationalCommerce"),
            meta: {
                requireAuth: true,
                sidebar: false,
                header: false
            }
        },
        {
            path: "/activity",
            redirect: "/activity/logs",
            component: () => import("./views/activity-logs/ActivityLogPage.vue"),
            meta: {
                requireAuth: true,
            },
            children: [
                {
                    path: "logs",
                    name: "ActivityLogs",
                    component: () => import("./views/activity-logs/LogsTab.vue"),
                    meta: {
                        requireAuth: true,
                    }
                }
            ]
        },
        {
            path: "/privilege-card",
            redirect: "/privilege-card/bundle",
            component: () => import("./views/privilege-card/Index.vue"),
            meta: {
                requireAuth: true,
            },
            children: [
                {
                    path: "bundle",
                    name: "PrivilegeCardBundle",
                    component: () => import("./views/privilege-card/PrivilegeCardBundleTab.vue"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "privilege-card.bundle",
                        module: "Privilege Card",
                        submodule: "Privilege Card Bundle"
                    }
                },
                {
                    path: "settings",
                    name: "PrivilegeCardSettings",
                    component: () => import("./views/privilege-card/PrivilegeCardSettingsTab.vue"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "privilege-card.settings",
                        module: "Privilege Card",
                        submodule: "Privilege Card Settings"
                    }
                }
            ]
        },
        {
            path: "/products",
            redirect: "/products/list",
            component: () => import("./views/products/Index.vue"),
            meta: {
                requireAuth: true,
                routeGroup: [
                    {
                        path: "/products/list",
                        access: "estore-products.inventory:topup-estore"
                    },
                    {
                        path: "/products/inventory",
                        access: "estore-products.branch-inventory:topup-estore"
                    },
                ],
            },
            children: [
                {
                    path: "list",
                    name: "Products",
                    component: () => import("./views/products/ProductsTab.vue"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "estore-products.inventory:topup-estore",
                        module: "E-Store Products",
                        submodule: "Products"
                    },
                    beforeEnter: (to, from, next) => {
                        if ("page" in from.params) {
                            store.commit(
                                "estoreInventories/setParamPage",
                                from.params.page
                            );
                        } else {
                            store.commit("estoreInventories/setParamPage", 1);
                        }
                        next();
                    }
                },
                {
                    path: "inventory",
                    name: "Inventory",
                    component: () => import("./views/products/InventoryTab.vue"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "estore-products.branch-inventory:topup-estore",
                        module: "Estore Products",
                        submodule: "Inventory"
                    }
                },
                {
                    path: "inventory/:productId",
                    props: true,
                    name: "ProductInventory",
                    component: () => import("./views/products/ProductInventoryPage.vue"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "estore-products.branch-inventory:topup-estore",
                        module: "Estore Products",
                        submodule: "Product Inventory"
                    }
                },
                {
                    path: "create",
                    name: "CreateProduct",
                    component: () => import("@/views/products/CreateProductPage"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "estore-products.inventory:topup-estore",
                        module: "E-Store Products",
                        submodule: "Create Product"
                    }
                },
                {
                    path: "update/:type/:uuid",
                    name: "UpdateProduct",
                    component: () => import("@/views/products/UpdateProductPage"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "estore-products.inventory:topup-estore",
                        module: "E-Store Products",
                        submodule: "Update Product"
                    }
                }
            ]
        },
        {
            path: "/orders",
            component: () => import("./views/orders/Index.vue"),
            meta: {
                requireAuth: true,
                routeGroup: [
                    {
                        path: "/orders/list",
                        access: "estore-orders.orders:topup-estore"
                    },
                    {
                        path: "/orders/payment-express",
                        access: "estore-orders.payment-express:topup-estore"
                    }
                ]
            },
            children: [
                {
                    path: "list",
                    name: "Orders",
                    component: () => import("./views/orders/OrdersTab.vue"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "estore-orders.orders:topup-estore",
                        module: "E-Store Orders",
                        submodule: "Orders"
                    }
                },
                {
                    path: "payment-express",
                    name: "payment-express",
                    component: () => import("./views/orders/PaymentExpressTab.vue"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "estore-orders.payment-express:topup-estore",
                        module: "E-Store Orders",
                        submodule: "Payment Express"
                    }
                },
                {
                    path: "dine-in",
                    name: "orders-dine-in",
                    component: () => import("./views/orders/OrdersDineInTab.vue"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "estore-orders.dine-in:topup-table_ordering",
                        module: "E-Store Orders",
                        submodule: "Table Ordering"
                    }
                }
            ]
        },
        {
            path: "/locations",
            component: () => import("./views/locations/Index.vue"),
            meta: {
                requireAuth: true,
            },
            children: [
                {
                    path: "/",
                    name: "Locations",
                    component: () =>
                        import("./views/locations/Locations.vue"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "estore-locations.locations:topup-estore",
                        module: "E-Store Locations",
                        submodule: "Locations"
                    }
                },
                {
                    path: ":branchUuid/products",
                    name: "LocationsProducts",
                    props: true,
                    component: () =>
                        import("./views/locations/Products.vue"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "estore-locations.locations:topup-estore",
                        module: "E-Store Locations",
                        submodule: "Products"
                    }
                }
            ]
        },
        {
            path: "/promo-codes",
            component: () => import("./views/promo-codes/Index.vue"),
            meta: {
                requireAuth: true,
            },
            children: [
                {
                    path: "",
                    name: "PromoCodes",
                    component: () => import("./views/promo-codes/PromoCodesTab.vue"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "estore-promo-codes.vouchers:topup-estore",
                        module: "E-Store Promo Codes",
                        submodule: "Promo Codes"
                    }
                },
            ]
        },
        {
            path: "/settings",
            component: () => import("./views/settings/Index.vue"),
            meta: {
                requireAuth: true,
            },
            children: [
                {
                    path: "",
                    name: "Settings",
                    component: () => import("./views/settings/SettingsTab.vue"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "estore-settings.settings:topup-estore",
                        module: "E-Store Settings",
                        submodule: "Settings"
                    }
                },
            ]
        },
        {
            path: "/punch-card",
            component: () => import("./views/punch-card/Index.vue"),
            meta: {
                requireAuth: true,
                routeGroup: [
                    {
                        path: "/punch-card/create",
                        access: "punch-card.campaigns"
                    },
                    {
                        path: "/punch-card/create/details",
                        access: "punch-card.campaigns"
                    },
                ]
            },
            children: [
                {
                    path: "",
                    name: "PunchCard",
                    component: () => import("./views/punch-card/List.vue"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "punch-card.campaigns",
                        module: "Punch Card",
                        submodule: "Campaigns"
                    }
                },
                {
                    path: "/punch-card/create",
                    name: "PunchCardCreate",
                    component: () => import("./views/punch-card/Create.vue"),
                    meta: {
                        requireAuth: true,
                        requirePermission: true,
                        access: "punch-card.campaigns",
                        module: "Punch Card",
                        submodule: "Campaigns"
                    }
                }
            ]
        }
    ],
    scrollBehavior() {
        document.getElementById('app').scrollIntoView({ behavior: 'smooth' });
    }
});

const checkViewTableGroupInfo = (to) => {
    if (to.name !== "ViewTables")
        localStorage.removeItem("viewTableInfo");
};

const checkPunchCard = (to, next) => {
    if (to.path.includes("punch-card") && !hasTopup("punchcard")) next({ path: "/" });
};

router.beforeEach(async (to, from, next) => {
    if (
        store.state.auth.user &&
        !store.state.onboarding.hasInitializedMerchantSetup &&
        hasTopup("estore")
    )
        await store.dispatch('onboarding/getMerchantSetup');

    if (
        to.params &&
        to.params.email_validation_code &&
        store.getters["auth/user"]
    )
        store.commit("auth/logout");
    if (from.name === "RushAcademy") {
        const rushAcademy = router.app.$children[0].$children.find(
            child => child.$el.id === "rush-academy"
        );
        const isVideoPlaying = rushAcademy.currentVideoDetail.is_playing;
        const isVideoSaved = rushAcademy.isSaved;
        if (!isVideoSaved && isVideoPlaying) {
            router.app.$root.$emit("router-change", to);
            return;
        } else next();
    }
    if (
        from.matched
            .map(matched => matched.name)
            .includes("advancedSettings")
    ) {
        const isShowSaveAlert = router.app.$children[0].$children.find(
            child => child.$el.id === "advanced-settings"
        ).$children[0].isShowSaveAlert;

        if (!isShowSaveAlert) next();
    } else if (
        from.matched.map(matched => matched.name).includes("Fulfillment")
    ) {
        const fulfillmentContainer = router.app.$children[0].$children.find(
            child => child.$el && child.$el.id === "fulfillment-container"
        );

        if (fulfillmentContainer && !fulfillmentContainer.isShowSaveAlert)
            next();
    } else if (
        store.state.accountProfile.detail.contract_status === "suspended" &&
        (to.name !== "MyPlanDetails" &&
            to.name !== "MyPlanBillingHistory" &&
            to.name !== "AddCreditCardDetails")
    ) {
    } // do nothing
    else if (
        (to.name == "estore-analytics"
            || to.name === "loyalty-analytics") &&
        screen.width <= 600
    ) {
        window.open(to.fullPath, '_blank');
    } else if (to.name == 'ConversationalCommerce') {
        const cms_permissions = store.getters['auth/user'].cms_permissions;
        const isCartlinkingEnabled = cms_permissions.includes('estore-orders.cartlinking:topup-estore');

        if (isCartlinkingEnabled) {
            next()
        } else {
            next('/account/profile')
        }
    }
    else if (
        to.name === "MyPlanDetails" &&
        !store.state.myPlan.tabs.some(({ name }) => name === "Plan Details")
    )
        next({ name: "MyPlanBillingHistory" });
    else next();

    checkViewTableGroupInfo(to);
    checkPunchCard(to, next);
});
/* -- End -- */

export default router;
